import type { VendorSummaryItem } from '@signalvote/shared';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { getReliabilityColor } from './colorUtils';

interface VendorSummaryCardsProps {
  vendors: VendorSummaryItem[];
  onNavigate: (vendorId: string) => void;
}

export function VendorSummaryCards({ vendors, onNavigate }: VendorSummaryCardsProps) {
  return (
    <Card>
      <CardContent className="pt-4">
        {vendors.length === 0 ? (
          <p className="text-sm text-muted-foreground">No vendor data</p>
        ) : (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {vendors.map((vendor) => (
              <Card
                key={vendor.vendorId}
                className="cursor-pointer card-interactive hover:ring-2 hover:ring-primary/50"
                onClick={() => onNavigate(vendor.vendorId)}
              >
                <CardHeader className="pb-2">
                  <CardTitle className="text-base">{vendor.vendorName}</CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="grid grid-cols-2 gap-2 text-sm text-muted-foreground">
                    <span>{vendor.canvasserCount} canvassers</span>
                    <span>{vendor.totalHours} hrs</span>
                    <span>{vendor.totalDoorsKnocked} doors</span>
                    <span>{vendor.totalContactsMade} contacts</span>
                  </div>
                  <div className="mt-2 flex items-center justify-between border-t pt-2 text-sm">
                    <span className="text-muted-foreground">Reliability</span>
                    <span className={`font-medium ${getReliabilityColor(vendor.reliabilityRate)}`}>
                      {vendor.reliabilityRate !== null
                        ? `${vendor.reliabilityRate.toFixed(1)}%`
                        : 'N/A'}
                    </span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
